// extracted by mini-css-extract-plugin
export default {"text-area":"DescriptionEditModal--text-area--UzYUi","textArea":"DescriptionEditModal--text-area--UzYUi"};